module.exports = __webpack_public_path__ + "static/paris-007.thumb-bbcf909bc77df39b7305284688480151.jpg";